<template>
    <ul class="tree">
        <node-tree :node="treeData"
                   @openProgramsDialog="openProgramsDialog"
                   @openQualificationsPanel="openQualificationsPanel"
                   @openTrainingPrograms="openTrainingPrograms"
                   @openAddPanel="openAddPanel" :read="read"></node-tree>
    </ul>
</template>

<script>
import NodeTree from './NodeTree';

export default {
    props: {
        treeData: Object,
        read: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NodeTree
    },
    methods: {
        openProgramsDialog(training) {
            this.$emit('openProgramsDialog', training)
        },
        openTrainingPrograms(training) {
          console.log()
        },
        openQualificationsPanel(qualification) {
            this.$emit('openQualificationsPanel', qualification)
        },
        openAddPanel(id = false) {
          this.$emit('openAddPanel', id)
        },
    }
}
</script>
<style>
  .tree {
    margin-top: 25px;
  }

</style>
